<template>
  <el-table
    :data="basicData"
    :show-header="false"
    border
  >
    <el-table-column
      prop="label"
    >
      <template slot-scope="scope">
        <strong>{{ scope.row.label }}</strong>
      </template>
    </el-table-column>
    <el-table-column
      prop="value"
    >
      <template slot-scope="scope">
        <el-tag type="danger" size="small" v-if="scope.row.tag">{{ scope.row.value }}</el-tag>
        <span v-if="!scope.row.tag">{{ scope.row.value }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  export default {
    props: ['userData'],
    data() {
      return {
        basicData: [],
      }
    },
    watch: {
      userData(newVal) {
        this.basicData =  [
          {
            label: 'Teljes név',
            value: newVal.last_name + ' ' + newVal.first_name
          },
          {
            label: newVal.roles.length > 1 ? 'Jogkörök' : 'Jogkör',
            value: newVal.roles.length === 0 ? 'Nincs jogkör' : newVal.roles.map(r => r.name).join(', '),
            tag: newVal.roles.length === 0,
          },
          {
            label: newVal.categories.length > 1 ? 'Csoportok' : 'Csoport',
            value: newVal.categories.length === 0 ? 'Nincs csoport' : newVal.categories.map(c => c.name).join(', '),
            tag: newVal.categories.length === 0,
          },
          {
            label: newVal.invoice_books.length > 1 ? 'Számlatömbök' : 'Számlatömb',
            value: newVal.invoice_books.length === 0 ? 'Nincs számlatömb' : newVal.invoice_books.map(c => c.name).join(', '),
            tag: newVal.invoice_books.length === 0,
          },
          {
            label: 'Felhasználónév',
            value: newVal.username
          },
          {
            label: 'E-mail',
            value: newVal.email
          },
          {
            label: 'Mobil',
            value: this.$options.filters.phone(newVal.mobile)
          },
          {
            label: 'Létrehozva',
            value: this.$options.filters.dateTime(newVal.created_at)
          },
          {
            label: 'Módosítva',
            value: this.$options.filters.dateTime(newVal.updated_at)
          },
        ];
      }
    }
  }
</script>
